/** A post lantern on its stone pad (lantern-water `world.js` `createTown`, the `lamp` pieces of `layout.js`); its light, if any, is the scene's. */
import * as THREE from 'three';
import type { Prefab } from './types.ts';

export const prefab: Prefab = {
  id: 'quay_lamp',
  buildPrefab(ctx) {
    const root = new THREE.Group();
    ctx.box(root, 0, 0.055, 0, 0.48, 0.11, 0.48, ctx.m.stone);
    ctx.lantern(root, 0, 2.6, 0, true);
    return { root, sockets: { light: [0, 2.6, 0.03] } };
  },
};
